import { Component } from '@angular/core';

import { Lab } from '../../shared/data/models/collections/lab';
import { Request } from '../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-labs',
  templateUrl: './labs.component.html',
  styleUrls: ['./labs.component.scss'],
})
export class LabsComponent extends AbstractLocalizedComponent {
  labs: Lab[];

  protected loadData(locale: string): void {
    this.labs = null;
    this.collectionsService.query<{ labs: Lab[] }>(Request.LABS, { locale }).subscribe(data => (this.labs = data.labs));
  }
}
